import React from 'react';
import { Modal, ModalContent, Button } from '@heroui/react';
import { Icon } from '@iconify/react';

const VerificationEmailModal = ({ isOpen, onClose, isError = false }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      placement="center"
      backdrop="blur"
      size="sm"
      classNames={{
        backdrop: "bg-gradient-to-t from-zinc-900 to-zinc-900/10 backdrop-opacity-20",
      }}
    >
      <ModalContent className="bg-white dark:bg-gray-800">
        {(onClose) => (
          <div className="flex flex-col items-center gap-6 p-8">
            {/* Icon */}
            <div className="w-20 h-20 rounded-full flex items-center justify-center bg-gray-100 dark:bg-gray-700">
              <Icon
                icon={
                  isError
                    ? 'solar:close-circle-bold'
                    : 'solar:letter-opened-bold'
                }
                className={`text-5xl ${
                  isError
                    ? 'text-red-600 dark:text-red-400'
                    : 'text-green-600 dark:text-green-400'
                }`}
              />
            </div>

            {/* Title */}
            <h3 className="text-2xl font-bold text-center text-gray-900 dark:text-gray-100">
              {isError ? 'Failed to Send' : 'Email Sent!'}
            </h3>

            {/* Message */}
            <p className="text-sm text-center leading-relaxed text-gray-600 dark:text-gray-300 px-2">
              {isError ? (
                <>
                  Failed to send verification email.
                  <br />
                  Please try again.
                </>
              ) : (
                <>
                  Verification email sent successfully!
                  <br />
                  Please check your inbox and click the verification link.
                  <br />
                  <span className="text-xs text-gray-500 dark:text-gray-400 mt-1 inline-block">
                    Don't see it? Check your spam folder.
                  </span>
                </>
              )}
            </p>

            {/* Action Button */}
            <Button
              onPress={onClose}
              color="primary"
              className="w-full font-semibold"
              size="lg"
            >
              Got it!
            </Button>
          </div>
        )}
      </ModalContent>
    </Modal>
  );
};

export default VerificationEmailModal;
